import api from '../api'

const baseUrl = '/academy/api/Discount'

const skillUpDiscountProvider = {
  getProductsTable(params) {
    return api.post(`${baseUrl}/ProductTable`, params)
  },

  getProductUser(params) {
    return api.post(`${baseUrl}/PeopleTable`, params)
  },

  getDiscount(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addUser(params) {
    return api.post(`${baseUrl}/AddUser`, params)
  },

  deleteUser(params) {
    return api.delete(`${baseUrl}/DeleteUser`, { data: params })
  },

  addDiscount(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateDiscount(params = {}) {
    return api.post(`${baseUrl}/Edit`, params)
  },
}

export default skillUpDiscountProvider
